module.exports = __webpack_public_path__ + "img/upgrade.59d2bb75.svg";